import { requiredRoles } from '@/shared/utils/require-roles'
import { UserRole } from '@depanneo/types'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/org/$orgId/equipments/')({
  beforeLoad: () => {
    requiredRoles([UserRole.ADMIN, UserRole.FACILITY_MANAGER, UserRole.VIEWER])
  },
})
